//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { uploader } from '@/utils/uploadCloud';
import { clientFileDeleteApi, clientFileListApi, putRealName as _putRealName } from '@/api/enterprise';
import { fileLinkDownLoad, formatBytes, getFileType, isTypeImage } from '@/libs/public';
export default {
  name: 'File',
  props: {
    formInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  components: {
    imageViewer: function imageViewer() {
      return import('@/components/common/imageViewer');
    }
  },
  data: function data() {
    return {
      real_name: '',
      fileName: '',
      RealNameId: '',
      dialogFormVisible: false,
      fileData: [],
      where: {
        page: 1,
        limit: 15,
        eid: 0,
        cid: 0
      },
      percentShow: false,
      percent: 0,
      timer: null,
      total: 0,
      loading: false,
      srcList: [],
      fileParams: {},
      myHeaders: {
        authorization: 'Bearer ' + localStorage.getItem('token')
      }
    };
  },
  mounted: function mounted() {
    // 设置上传参数
    this.fileParams.relation_type = 'client';
    this.fileParams.eid = this.formInfo.data.eid;
    this.fileParams.cid = this.formInfo.data.cid;
    this.where.eid = this.formInfo.data.eid;
    this.where.cid = this.formInfo.data.cid;
  },
  methods: {
    getTableData: function getTableData() {
      var _this = this;
      this.fileParams.eid = this.formInfo.data.eid;
      clientFileListApi(this.where).then(function (res) {
        _this.fileData = res.data.list;
        _this.fileParams.eid = _this.formInfo.data.eid;
        _this.total = res.data.count;
        if (_this.fileData.length > 0) {
          _this.fileData.map(function (value) {
            if (_this.fileIsImage(value.att_type)) {
              _this.srcList.push(value.att_dir);
            }
          });
        }
      });
    },
    pageChange: function pageChange(val) {
      this.where.page = val;
      this.getTableData();
    },
    formatBytesFn: function formatBytesFn(size) {
      if (size) {
        return formatBytes(Number(size));
      } else {
        return '--';
      }
    },
    uploadServerLog: function uploadServerLog(params) {
      var _this2 = this;
      this.percentShow = true;
      var file = params.file;
      uploader(file, 0, 15, this.fileParams).then(function (res) {
        // 获取上传文件渲染页面
        if (res.name) {
          _this2.getTableData();
          _this2.percentShow = false;
        }
      }).catch(function (err) {
        _this2.percentShow = false;
      });
    },
    toSrcIcon: function toSrcIcon(name) {
      return getFileType(name);
    },
    // 查看与下载附件
    lookViewer: function lookViewer(url) {
      var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      if (isTypeImage(url)) {
        this.$refs.imageViewer.openImageViewer(url);
      } else {
        fileLinkDownLoad(url, name);
      }
    },
    getFileLinkDownLoad: function getFileLinkDownLoad(url, name) {
      fileLinkDownLoad(url, name);
    },
    isFileImage: function isFileImage(name) {
      return isTypeImage(name);
    },
    // 重命名
    handleLabel: function handleLabel(row) {
      this.RealNameId = row.id;
      this.dialogFormVisible = true;
      this.real_name = row.real_name;
    },
    putRealName: function putRealName() {
      var _this3 = this;
      var data = {
        real_name: this.real_name
      };
      _putRealName(this.RealNameId, data).then(function (res) {
        _this3.dialogFormVisible = false;
        _this3.getTableData();
      });
    },
    // 删除附件
    handleFileDelete: function handleFileDelete(row, index) {
      var _this4 = this;
      this.$modalSure('附件删除后，不可恢复，确认要删除吗').then(function () {
        clientFileDeleteApi(row.id).then(function (res) {
          _this4.fileData.splice(index, 1);
          if (_this4.where.page > 1 && _this4.fileData.length <= 0) {
            _this4.where.page--;
          }
          _this4.getTableData();
        });
      });
    }
  }
};